var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33551",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33551)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H24V0H0V5.33333Z",
    fill: "#E41D33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H24V10.6667H0V16Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5635 7.6241L10.8437 8.14707L11.1445 7.63598L11.1445 7.63592L11.1446 7.63586L11.1446 7.63581L11.1446 7.63577L11.1455 7.63436L11.1498 7.62719L11.1682 7.59713C11.1848 7.5706 11.2094 7.532 11.2405 7.48538C11.3033 7.39155 11.391 7.26812 11.4921 7.14625C11.5947 7.02261 11.7032 6.91043 11.8063 6.83186C11.9167 6.74781 11.9803 6.73336 12.0002 6.73336C12.041 6.73336 12.1139 6.75427 12.2204 6.83378C12.3232 6.91055 12.4282 7.02038 12.5261 7.14215C12.6226 7.26222 12.7043 7.384 12.7622 7.47669C12.7909 7.5227 12.8134 7.56075 12.8283 7.58679C12.8358 7.5998 12.8413 7.60975 12.8449 7.61615L12.8486 7.623L12.8492 7.6241L12.8493 7.62421L12.8493 7.62429L12.8493 7.62429L12.8494 7.62438L13.1431 8.17257L13.4369 7.6241L13.9141 6.73336L14.1907 6.73336C14.3748 6.73336 14.524 6.8826 14.524 7.06669V8.40002C14.524 8.66154 14.2366 8.8212 14.0146 8.68304L13.3192 8.25034L13.2383 8.20002H13.1431H12.5716H12.2383V8.53336V9.02859C12.2383 9.16009 12.1317 9.26669 12.0002 9.26669C11.8687 9.26669 11.7621 9.16009 11.7621 9.0286V8.53336V8.20002H11.4288H10.8574H10.7621L10.6813 8.25034L9.98583 8.68304C9.76379 8.8212 9.4764 8.66154 9.4764 8.40002V7.06669C9.4764 6.8826 9.62564 6.73336 9.80973 6.73336H10.0863L10.5635 7.6241Z",
    fill: "#F4B32E",
    fillOpacity: 0.25,
    stroke: "#C6A846",
    strokeWidth: 0.666667
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/EG.d6006c47ed462fe5ebaafcf28a5ea45f.svg";
export { ForwardRef as ReactComponent };